import { useEffect, useMemo, useState } from 'react';

import {
  getSessionPrepSortTime,
  mapArtifactToNextSessionPrep,
} from './sessionReflectionHomeUtils';

import { useGetMomentsMemberArtifactsQuery } from '@/store/api/momentsApi';

export const SESSION_PREP_MEMBER_PROFILE_SLUG = 'session-prep-member';
export const HOME_SESSION_PREP_LIMIT = 100;
const SESSION_PREP_NOW_REFRESH_MS = 60_000;

export type SessionPrepHomeStatus = 'error' | 'loading' | 'ready';

export const useMemberSessionPrepHome = () => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = window.setInterval(
      () => setNow(Date.now()),
      SESSION_PREP_NOW_REFRESH_MS,
    );
    return () => window.clearInterval(interval);
  }, []);
  const artifactsArg = {
    includeContent: false,
    limit: HOME_SESSION_PREP_LIMIT,
    profileSlug: SESSION_PREP_MEMBER_PROFILE_SLUG,
  };
  const { data, isError, isLoading } =
    useGetMomentsMemberArtifactsQuery(artifactsArg);

  const prep = useMemo(
    () =>
      [...(data?.items ?? [])]
        .filter(
          (artifact) =>
            artifact.profileSlug === SESSION_PREP_MEMBER_PROFILE_SLUG,
        )
        .map((artifact) => mapArtifactToNextSessionPrep(artifact, now))
        .filter((row): row is NonNullable<typeof row> => row !== null)
        .sort(
          (a, b) => getSessionPrepSortTime(a) - getSessionPrepSortTime(b),
        )[0] ?? null,
    [data?.items, now],
  );

  let status: SessionPrepHomeStatus = 'ready';
  if (isLoading) {
    status = 'loading';
  } else if (isError && prep === null) {
    status = 'error';
  }

  return {
    isLoading: status === 'loading',
    prep,
    status,
  };
};
